import { defineAsyncComponent } from 'vue';

export default ({
	forms: {
		edit: {
			panel: {
				// height: '280px',
				width: '70%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			config: {
			},
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				width: '70%'
			},
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					name: {},
				}
			}
		}
	}
})